import environment from "../../../environment/environment";
import routes from "../common/api-routes";
import {HttpGet, HttpPut} from "../common/HttpRequestBuilder";

const SUBSCRIPTION_KEY = environment.service_baseUrl.subscriptionKey;

const getAnomalyDetectionDetailView = (anomalyId) => {

    let query_params = {
        anomalyId: anomalyId
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_ANOMALY_DETECTION_DETAIL_VIEW, query_params, subscriptionKey);
    return result;
}

const createAnomalyDetectionRemarks = (anomalyId, remarks) => {

    let payload = {
        anomalyId: anomalyId,   
        remarks: remarks
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpPut(routes.CREATE_ANOMALY_DETECTION_REMARKS, payload, subscriptionKey);
    return result;
}

const invalidateAnomalyDetectionRemarks = (anomalyId, remarks) => {

    let payload = {
        anomalyId: anomalyId,   
        remarks: remarks
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpPut(routes.INVALIDATE_ANOMALY_DETECTION_REMARKS, payload, subscriptionKey);
    return result;
}

const getHistoryLogList = (anomalyId) => {

    let query_params = {
        anomalyId: anomalyId
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_HISTORY_LOG_LIST, query_params, subscriptionKey);
    return result;
}

const getAnomalyList = (startDate, endDate, selectedFraud) => {

    let query_params = {
        startDate: startDate,
        endDate: endDate,
        fraudType: selectedFraud
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_ANOMALY_LIST, query_params, subscriptionKey);
    return result;
}

const getSearchAnomalyList = (startDate, endDate, ovi) => {

    let query_params = {
        startDate: startDate,
        endDate: endDate,
        ovi: ovi
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_ANOMALY_LIST, query_params, subscriptionKey);
    return result;
}

const getAnomalyDetectionList = (startDate, endDate) => {

    let query_params = {
        startDate: startDate,
        endDate: endDate,
    }

    let subscriptionKey = SUBSCRIPTION_KEY;
    let result = HttpGet(routes.GET_ANOMALY_DETECTION_LIST, query_params, subscriptionKey);
    return result;
}


const AnomalyDetectionService = {
    getAnomalyDetectionDetailView,
    createAnomalyDetectionRemarks,
    invalidateAnomalyDetectionRemarks,
    getHistoryLogList,
    getAnomalyList,
    getSearchAnomalyList,
    getAnomalyDetectionList,
}

export default AnomalyDetectionService
